module.exports = __webpack_public_path__ + "img/07.ad36ae55.jpg";